module.exports = __webpack_public_path__ + "housingStatic/img/login_house.50547b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login_temp/login_house.png
// module id = QLTR
// module chunks = 2